import * as React from 'react';

interface Props {
  url: string;
  style?: React.CSSProperties;
  className?: string;
}

export const CalendarSchedule: React.FC<Props> = (props) => {
  const { url, style, className } = props;
  return (
    <iframe style={style} className={`w-full h-[700px] ${className}`} title="Schedule" src={url} />
  );
};
CalendarSchedule.displayName = 'CalendarSchedule';
